import { Component, Injector, COMPILER_OPTIONS, NgModule, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Events, ModalController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Menu } from '../menu/menu';
import { Profilo } from '../profilo/profilo';
import { Impostazioni } from '../impostazioni/impostazioni';
import { BadgePage } from '../badge/badge';
import { Global_Statistiche } from '../global_statistiche/global_statistiche';
import { makePropDecorator } from '@angular/core/src/util/decorators';
import { ClockComponent } from '../component/clock';
import { ClassifichePage } from '../classifiche/classifiche';
import { Firebase } from '@ionic-native/firebase';
import { CircleProgressComponent } from 'ng-circle-progress';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
import { SelectSquadraPage } from '../select-squadra/select-squadra';
// import { ModalFasi } from '../modal_fasi/modal_fasi';
import { ModalfasixPage } from '../modalfasix/modalfasix';
import { Info } from '../info/info';
import { ConfirmLogout } from '../confirmLogout/confirmLogout';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
// @NgModule({
//   imports: [CircleProgressComponent],
//   // schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
// })
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class Dashboard extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  point_select: string;
  getbg = { allena: {}, apprendi: {}, competenze: {}, shop: {} };
  getbg_ = { costanza: {}, tempo: {}, completati: {} };
  percent_hat: any = 1;
  allena_arr = [];
  apprendi_arr = [];
  competenze_arr = [];
  competenzaselect: any = {};
  statistiche: any = [];
  costanza: any = {};
  tempo: any = {};
  completati: any = {};
  url = document.URL;
  showcompetenza: boolean = false;
  language = 'it';
  scheda_selezionata = '';
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    injector: Injector,
    loading: LoadingController,
    hat: HatComponent,
    lancets: LancetsComponent,
    linesvg: LineSvgComponent,
    userstar: UserStarComponent,
    clock: ClockComponent,
    public theme: EthemeProvider,
    public modalController: ModalController,
    private firebase: Firebase, public event: Events) {
    super(injector, loading);

    this.page = 'dash';
    this.point_select = 'dash';
    this.competenzaselect = {};
    // var loading_ = this.loadingCtrl.create({
    //   content: ''
    // });
    // loading_.present();
    this.event.subscribe('refreshdashboard', () => {
      this.refreshpage();
    });
  }


  ionViewWillEnter() {
    this.navCtrl.swipeBackEnabled = false;
  }
  isMobilexx = false;
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.GetRequest('me', '', true, false).then((userdata) => {
      this.user = userdata['user'];
      this.gs.userx = this.user;
      // console.log(userdata);
    });
    if (this.etheme.theme_selected == 'sky-theme') {
      this.open_modal_selectsquadra();
    }

    this.refreshpage();
    console.log(window.outerWidth);
    if (window.outerWidth > 850) {
      this.isMobilexx = false;
    }
    else {
      this.isMobilexx = true;
    }
    //   this.open_vertical_box('completati');

    this.language = this.translate.getDefaultLang();

  }
  @HostListener("window:resize", ["$event"]) onResize(event) {
    if (window.outerWidth > 850) {
      this.isMobilexx = false;
    }
    else {
      this.isMobilexx = true;
    }
  }
  check_tabbar() {

    if (this.isMobilexx == true && this.point_select == 'dash')
      return true;
    else if (this.isMobilexx == true && this.point_select != 'dash')
      return false;
    else if (this.isMobilexx == false)
      return true;
  }
  open_mj(circle) {
    // console.log(circle);
    this.mjl.forEach(element => {
      if (element.id == circle.mjid) {
        this.mjl_detail(element);
      }
    });
  }
  refreshpage() {


    this.GetRequest('microjourneyListNew', '').then(data => {


      this.storage.get('user').then(user => {
        this.storage.get('tokenFCM').then((tokenfcm) => {
          if (tokenfcm != '' && tokenfcm != undefined && tokenfcm != null) {
            if (this.etheme.theme_selected == 'mygame-theme') {
              this.PostRequest('register_device', '', { 'cliente': 'mygame', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {

              })
            }
            else if (this.etheme.theme_selected == 'dark-theme_') {
              this.PostRequest('register_device', '', { 'cliente': 'eydlab', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {

              })
            }
            else if (this.etheme.theme_selected == 'yamamay-theme') {
              this.PostRequest('register_device', '', { 'cliente': 'yamamay', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {

              })
            }
            else if (this.etheme.theme_selected == 'carrefour-theme') {

              this.PostRequest('register_device', '', { 'cliente': 'carrefour', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {

              })

            }
            else if (this.etheme.theme_selected == 'noeinglese-theme') {

              this.PostRequest('register_device', '', { 'cliente': 'noeformazione', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {

              })

            }
          }
        })
        if (user && user.token) {

          let webkit = (window as any).webkit;

          if (webkit != undefined) {
            webkit.messageHandlers.jsHandler.postMessage(JSON.stringify({
              method: "register_device",
              data: {
                token: user.token,
                url: this.urlserver
              }
            }));
          }

        }

      });

      if (data['popup'] != null && data['popup'] != '')
        this.openconfirm(data['popup']);
      //this.mjl = data['MicroJourneyList']['da_iniziare']; 
      this.allena_arr = [];
      this.apprendi_arr = [];
      this.mjl = data['MicroJourneyList'];
      for (let i = 0; i < this.mjl.length; i++) {
        const element = this.mjl[i];
        if (element.tipo == 'allena') {
          // element.logoIMG = 'https://st.depositphotos.com/2290789/3667/i/600/depositphotos_36675429-stock-photo-king-lion-aslan.jpg';
          this.allena_arr.push(element);
        }
        else if (element.tipo == 'apprendi')
          this.apprendi_arr.push(element);
      }

      // console.log(this.apprendi_arr);
    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })

    this.GetRequest('competenzeList', '', false, false).then(data => {
      // console.log(data);
      this.competenze_arr = data['CompetenzaList'];
      // console.log(this.competenzaselect);
      /*this.competenze_arr[0].listMicroJourney[0].microJourney.percCompletato = 50;
      this.competenze_arr[0].listMicroJourney[1].microJourney.percCompletato = 80;
      this.competenze_arr[0].listMicroJourney[2].microJourney.percCompletato = 30;*/

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })

    this.GetRequest('statistiche', '', false, false).then(data => {
      // console.log(data);
      this.statistiche = data;
      this.costanza = data[0];
      this.tempo = data[1];
      this.completati = data[2];
      this.completati['titolo_1'] = this.completati['titolo'].replace('Corsi', 'Percorsi');
      this.completati['titolo_2'] = this.completati['titolo'].replace(' Completati', '').replace('Corsi', 'Percorsi');
      this.percent_hat = this.completati['numero'] / this.completati['totale'] * 100;

      this.scheda_selezionata = 'allena';
      this.open_page('allena');

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }

  open_compentenza(c) {
    this.showcompetenza = true;
    this.competenzaselect = c;
  }
  close_competenza() {
    this.showcompetenza = false;
    this.competenzaselect = {};
  }


  ionViewDidLoad() {
    // console.log('xxxxxxxxxxxxxxxx');
    /*this.storage.get('refr').then((res) => {
      if (res != 1) {
        this.storage.set('refr', 1).then(() => {
          this.navCtrl.setRoot(this.navCtrl.getActive().component).then(() => {
            this.storage.set('refr', 0);
          })
        })
      }

    })*/

  }
  open_vertical_box(x) {
    this.point_select = x;
    for (let n in this.getbg_) {
      this.getbg_[n] = '';
    }
    this.getbg_[x] = 'attivo';

    var bvb = document.getElementsByClassName("button-vertical-bar");
    var i;
    for (i = 0; i < bvb.length; i++) {
      var l = bvb[i];
      l.classList.add('display_responsive');
    }
  }
  squadre = [];
  open_modal_selectsquadra() {

    this.GetRequest('check_squadra_sky', '', true, true).then((squadrex: any) => {
      // if (squadrex.length > 0) {
      this.squadre = squadrex['SquadraList'];
      // this.squadreaux = squadrex['SquadraList'];
      if (this.squadre.length > 0) {
        const modal = this.modalCtrl.create(SelectSquadraPage, { 'squadre': this.squadre }, { enableBackdropDismiss: false });
        modal.onDidDismiss(data => {
          // console.log(data);
          if (data) {
            this.PostRequest('iscrizione_squadra_sky', data.id, {}, true, true).then((r) => {
              // console.log(r);
              this.refreshpage();
            }).catch((e) => {
              //this.navCtrl.push(Mj_Detail,{mj:m});
              console.error(e);
              setTimeout(() => {
                this.open_modal_selectsquadra();
              }, 2000);


            })
          }
        });
        modal.present();
      }
      // }
    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })

  }
  fasi;

  mjl_detail_popup(mj) {
    this.GetRequest('fasiMicroJourneyMini', mj.id).then(data => {
      this.fasi = data['FaseList'];
      const modal = this.modalCtrl.create(ModalfasixPage, { fasi: this.fasi, mj: mj }, { cssClass: 'modalfasi' });
      modal.present();
      modal.onDidDismiss((data) => {
        if (data == 'start')
          this.mjl_detail(mj);
      })

    }).catch((e) => {
      console.error(e)
    })


  }



  mjl_detail(m) {
    // console.log(m);
    if (m.linkEsterno != null) {
      window.open(m.linkEsterno, '_blank');
      return;
    }
    this.translate.get('dashboard.ATTIVAPERCORSO', { nome: m.nome }).subscribe(v => {
      if (m.stato == 'da_iniziare') {
        this.presentPopover(event, Confirm, v).then((data) => {
          // console.log(data);
          if (data == 'confirm') {
            this.PostRequest('attivaMJ', m.id, {}, true, true).then((res) => {
              // console.log(res);
              m.stato = 'in_corso';
              //TO DO controllo che è andato sullo stato creato
              this.navCtrl.push(Mj_Detail, { mj: m, 'user': this.user }, { animate: false });

            }).catch((e) => {
              //this.navCtrl.push(Mj_Detail,{mj:m});
              console.error(e);
            })
          }
        })
      }
      else
        this.navCtrl.push(Mj_Detail, { mj: m, 'user': this.user }, { animate: false });
      //Open Popup p
    });

  }
  open_menu() {
    // console.log('open menu');
    this.navCtrl.push(Menu, { statistiche: this.statistiche }, { animate: false });
  }
  open_page_desktop(page) {
    switch (page) {
      case 'profilo':
        this.navCtrl.push(Profilo, '', { animate: false });
        break;
      case 'impostazioni':
        this.navCtrl.push(Impostazioni, '', { animate: false });
        break;
      case 'badge':
        this.navCtrl.push(BadgePage, '', { animate: false });
        break;
      case 'statistiche':
        this.navCtrl.push(Global_Statistiche, { statistiche: this.statistiche }, { animate: false });
        break;
      case 'classifiche':
        this.navCtrl.push(ClassifichePage, { user: this.user }, { animate: false });
        break;
    }
  }
  open_page(page) {
    // console.log(page);
    this.page = page;
    for (let n in this.getbg) {
      this.getbg[n] = '';
    }
    this.getbg[page] = 'attivo_';

  }
  doSomethingWithCurrentValue(ev) {
    //console.log(ev);
  }
  openconfirm(message) {
    // this.translate.get('dashboard.CONFERMARE').subscribe(v => {
    // message= "Ciao! ci sono novità!<br>Da oggi puoi mettere in pausa le sessioni di allenamento che stai svolgendo. Per farlo ti basterà cliccare sulla “freccia indietro” che trovi in alto a sinistra della pagina.<br>Le sessioni messe in pausa saranno contrassegnate in questo modo:  . Potrai riprendere il quiz quando vorrai, ma ricorda di stare sempre attento alle scadenze e tempistiche previste dal tuo percorso!<br>Fai attenzione ad alcuni accorgimenti:<br><ul><li>Prima di svolgere nuovi quiz nella stessa sessione dovrai terminare quelli in pausa.</li><li>Non potrai mettere in pausa la compilazione durante le domande a tempo, per farlo dovrai procedere fino alla prima domanda non temporizzata.</li><li>Nel momento in cui, per qualsiasi motivo, una sessione sarà resettata, i tentativi in pausa al suo interno verranno cancellati.</li></ul>Se dovessi incontrare problemi con questa nuova funzione scrivici alla mail supporto@skilleyd.net."
    this.presentPopover_iniziale(event, Info, message).then((data) => {
      // console.log(data);
    })
    // });
  }
  // logout() {
  //   this.storage.get('language').then((lan) => {
  //     var language = lan;
  //     this.storage.remove('user').then(() => {
  //       // this.storage.clear();
  //       this.storage.set('language', language).then((lan) => {
  //         if (this.etheme.theme_selected == 'sky-theme') {
  //           let url = document.URL;
  //           window.location.href = url.replace('?login=sso', '');
  //         }
  //         else
  //           window.location.reload();
  //       })
  //     });
  //   })
  // }

  logout_yamapp(){
    this.presentPopover(event, ConfirmLogout, 'Vuoi tornare al portale Yamacademy o vuoi uscire da YamApp?').then((data) => {
     
      if(data == 'confirm'){
        
        window.location.href = 'https://learning.yamacademy.it/';
      }
      else if(data == 'exit'){
        //ESCI DA YAMAPP
        this.logout();
      }
    })
  }

  logout() {
    
    this.storage.get('user').then(user => {
      this.storage.get('tokenFCM').then((tokenfcm) => {
        if (tokenfcm != '' && tokenfcm != undefined && tokenfcm != null) {
          if (this.etheme.theme_selected == 'mygame-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'mygame', 'device': 'Android', 'tokenFCM': tokenfcm }, false, false).then((r) => {
          
            })
          }
          else if (this.etheme.theme_selected == 'dark-theme_' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'eydlab', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
       
            })
          }
          else if (this.etheme.theme_selected == 'yamamay-theme') {
            this.PostRequest('remove_device', '', { 'cliente': 'yamamay', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
         
            })
          }
          else if (this.etheme.theme_selected == 'carrefour-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'carrefour', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
       
            })
          }
          else if (this.etheme.theme_selected == 'noeinglese-theme' ) {
            this.PostRequest('remove_device', '', { 'cliente': 'noeformazione', 'device': 'Android', 'tokenFCM': tokenfcm}, false, false).then((r) => {
       
            })
          }
        }
      })
      if (user != undefined) {
        let webkit = (window as any).webkit;
        if (webkit != undefined) {
          webkit.messageHandlers.jsHandler.postMessage(JSON.stringify({
            method: "remove_device",
            data: {
              token: user.token,
              url: this.urlserver
            }
          }));
        }
      }

      this.cleardata();
    },
      error => {
        this.cleardata();
      });


  }

  cleardata() {
    this.storage.get('language').then((lan) => {
      var language = lan;
      this.storage.remove('user').then(() => {
        // this.storage.clear();
        this.storage.set('language', language).then((lan) => {
          if (this.etheme.theme_selected == 'sky-theme' || this.etheme.theme_selected == 'yamamay-theme' || this.etheme.theme_selected == 'carrefour-theme') {
            let url = document.URL;
            window.location.href = url.replace('?login=sso', '');
          }
          else
            window.location.reload();
          // window.location.reload();
        })
      });
    })

  }

  back() {
    for (let n in this.getbg) {
      this.getbg[n] = '';
    }
    var bvb = document.getElementsByClassName("button-vertical-bar");
    var i;
    for (i = 0; i < bvb.length; i++) {
      var l = bvb[i];
      l.classList.remove('display_responsive');
    }
    this.page = 'dash';
    this.point_select = 'dash';
    // this.open_vertical_box('completati');  
    for (let n in this.getbg_) {
      this.getbg_[n] = '';
    }
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts